// PayTR her gün 10:00–11:30 (İstanbul) arasında ödeme çıkışı yapıyor ve bu aralıkta
// iade/iptal kabul etmiyor. Asıl kontrol backend'de; burada kullanıcı boşuna denemesin diye.
export const PAYTR_REFUND_CLOSED_MESSAGE =
    "PayTR her gün 10:00–11:30 arasında ödeme çıkışı yaptığı için bu saatlerde iade ve iptal işlemi yapılamıyor. Lütfen 11:30'dan sonra tekrar deneyin.";

const istanbulMinutes = (date) => {
    const parts = new Intl.DateTimeFormat("en-GB", {
        timeZone: "Europe/Istanbul", hour: "2-digit", minute: "2-digit", hourCycle: "h23",
    }).formatToParts(date);
    const get = (type) => Number(parts.find((p) => p.type === type)?.value);
    return get("hour") * 60 + get("minute");
};

export const isPaytrRefundClosed = (date = new Date()) => {
    const m = istanbulMinutes(date);
    return m >= 10 * 60 && m < 11 * 60 + 30;
};
